/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Realtime_Errors_Aria_LabelInputs */

const en_event_realtime_errors_aria_label = /** @type {(inputs: Event_Realtime_Errors_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show real-time errors`)
};

const fr_event_realtime_errors_aria_label = /** @type {(inputs: Event_Realtime_Errors_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher les erreurs en temps reel`)
};

const de_event_realtime_errors_aria_label = /** @type {(inputs: Event_Realtime_Errors_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echtzeitfehler anzeigen`)
};

const it_event_realtime_errors_aria_label = /** @type {(inputs: Event_Realtime_Errors_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra errori in tempo reale`)
};

const ru_event_realtime_errors_aria_label = /** @type {(inputs: Event_Realtime_Errors_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отображение ошибок в реальном времени`)
};

const es_event_realtime_errors_aria_label = /** @type {(inputs: Event_Realtime_Errors_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar errores en tiempo real`)
};

const zh_cn2_event_realtime_errors_aria_label = /** @type {(inputs: Event_Realtime_Errors_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示实时误差`)
};

const ja_event_realtime_errors_aria_label = /** @type {(inputs: Event_Realtime_Errors_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リアルタイムエラーを表示`)
};

const hi_event_realtime_errors_aria_label = /** @type {(inputs: Event_Realtime_Errors_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वास्तविक समय की त्रुटियाँ दिखाएँ`)
};

const pt_pt2_event_realtime_errors_aria_label = /** @type {(inputs: Event_Realtime_Errors_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exibir erros em tempo real`)
};

/**
* | output |
* | --- |
* | "Show real-time errors" |
*
* @param {Event_Realtime_Errors_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_realtime_errors_aria_label = /** @type {((inputs?: Event_Realtime_Errors_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Realtime_Errors_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_realtime_errors_aria_label(inputs)
	if (locale === "de") return de_event_realtime_errors_aria_label(inputs)
	if (locale === "it") return it_event_realtime_errors_aria_label(inputs)
	if (locale === "ru") return ru_event_realtime_errors_aria_label(inputs)
	if (locale === "es") return es_event_realtime_errors_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_realtime_errors_aria_label(inputs)
	if (locale === "ja") return ja_event_realtime_errors_aria_label(inputs)
	if (locale === "hi") return hi_event_realtime_errors_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_realtime_errors_aria_label(inputs)
	return en_event_realtime_errors_aria_label(inputs)
});